export { default } from "./MeridianLanding";
